const PERIODS = Object.freeze({
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  WEEK_TO_DATE: 'week_to_date',
  LAST_WEEK: 'last_week',
  THIS_WEEK: 'this_week',
  MONTH_TO_DATE: 'month_to_date',
  LAST_MONTH: 'last_month',
  LAST_3_MONTHS: 'last_3_months',
  LAST_6_MONTHS: 'last_6_months',
  YEAR_TO_DATE: 'year_to_date',
  LAST_YEAR: 'last_year',
  ALL_TIME: 'all_time',
  CUSTOM: 'custom',
  PREVIOUS_PERIOD: 'previous_period',
  PREVIOUS_YEAR: 'previous_year',
  NONE: 'NONE',
  AS_PER_PLAN: 'AS_PER_PLAN',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY'
})

export default PERIODS

export const TIME_PERIODS = Object.freeze({
  TODAY: PERIODS.TODAY,
  YESTERDAY: PERIODS.YESTERDAY,
  WEEK_TO_DATE: PERIODS.WEEK_TO_DATE,
  LAST_WEEK: PERIODS.LAST_WEEK,
  MONTH_TO_DATE: PERIODS.MONTH_TO_DATE,
  LAST_MONTH: PERIODS.LAST_MONTH,
  LAST_3_MONTHS: PERIODS.LAST_3_MONTHS,
  LAST_6_MONTHS: PERIODS.LAST_6_MONTHS
})

export const COMPARE_PERIODS = Object.freeze({
  CUSTOM: PERIODS.CUSTOM,
  PREVIOUS_PERIOD: PERIODS.PREVIOUS_PERIOD,
  PREVIOUS_YEAR: PERIODS.PREVIOUS_YEAR
})
// Dashboard Graph Options
export const COMPARE_OPTIONS = [
  { label: 'Custom', value: COMPARE_PERIODS.CUSTOM },
  { label: 'Previous Period', value: COMPARE_PERIODS.PREVIOUS_PERIOD },
  { label: 'Previous Year', value: COMPARE_PERIODS.PREVIOUS_YEAR }
]

export const PERIOD_OPTIONS = [
  { label: 'Today', value: TIME_PERIODS.TODAY, compare: COMPARE_OPTIONS },
  { label: 'Yesterday', value: TIME_PERIODS.YESTERDAY, compare: COMPARE_OPTIONS },
  { label: 'Week to date', value: TIME_PERIODS.WEEK_TO_DATE, compare: COMPARE_OPTIONS },
  { label: 'Last Week', value: TIME_PERIODS.LAST_WEEK, compare: COMPARE_OPTIONS },
  { label: 'Month to date', value: TIME_PERIODS.MONTH_TO_DATE, compare: COMPARE_OPTIONS },
  { label: 'Last Month', value: TIME_PERIODS.LAST_MONTH, compare: COMPARE_OPTIONS },
  { label: 'Last 3 Months', value: TIME_PERIODS.LAST_3_MONTHS, compare: COMPARE_OPTIONS },
  { label: 'Last 6 Months', value: TIME_PERIODS.LAST_6_MONTHS, compare: COMPARE_OPTIONS }
]
